import axios from 'axios';
import Jsona from 'jsona';

const url = process.env.VUE_APP_API_BASE_URL;
const jsona = new Jsona();

function get(id) {
  const options = {
    headers: {
      'Accept': 'application/vnd.api+json',
      'Content-Type': 'application/vnd.api+json',
    }
  };

  return axios.get(`${url}/documentar_equipaje/buscarBoleto/${id}`, options)
    .then(response => {
      let document = jsona.deserialize(response.data);
      delete document.links;
      return document;
    });
}

function add(checkLuggage) {
  const payload = jsona.serialize({
    stuff: checkLuggage,
    includeNames: null
  });

  const options = {
    headers: {
      'Accept': 'application/vnd.api+json',
      'Content-Type': 'application/vnd.api+json',
    }
  };

  return axios.post(`${url}/documentar_equipaje/extra`, payload, options)
    .then(response => {
      return response.data;
    });
}

function addFree(checkLuggage) {
  const payload = jsona.serialize({
    stuff: checkLuggage,
    includeNames: null
  });

  const options = {
    headers: {
      'Accept': 'application/vnd.api+json',
      'Content-Type': 'application/vnd.api+json',
    }
  };

  return axios.post(`${url}/documentar_equipaje/gratis`, payload, options)
    .then(response => {
      return response.data;
    });
}

export default {
  get,
  add,
  addFree,
};

